import BaseService from "services/BaseService";

class MasterContentService extends BaseService {
  listPosts = async (payload) => this._api.post("master/content/post/list", payload || {});
  getPost = async ({ id }) => this._api.post("master/content/post/get", { id });
  createPost = async (payload) => this._api.post("master/content/post/create", payload || {});
  updatePost = async (payload) => this._api.post("master/content/post/update", payload || {});
  deletePost = async ({ id }) => this._api.post("master/content/post/delete", { id });
  checkSlug = async ({ slug, exclude_id }) => this._api.post("master/content/post/check_slug", { slug, exclude_id });

  listCategories = async (payload) => this._api.post("master/content/category/list", payload || {});
  createCategory = async (payload) => this._api.post("master/content/category/create", payload || {});
  updateCategory = async (payload) => this._api.post("master/content/category/update", payload || {});
  deleteCategory = async ({ id }) => this._api.post("master/content/category/delete", { id });

  listTags = async (payload) => this._api.post("master/content/tag/list", payload || {});
  createTag = async (payload) => this._api.post("master/content/tag/create", payload || {});
  updateTag = async (payload) => this._api.post("master/content/tag/update", payload || {});
  deleteTag = async ({ id }) => this._api.post("master/content/tag/delete", { id });

  listRevisions = async ({ post_id }) => this._api.post("master/content/revision/list", { post_id });
  restoreRevision = async ({ revision_id }) => this._api.post("master/content/revision/restore", { revision_id });

  getBrandProfile = async () => this._api.post("master/content/brand-profile/get", {});
  updateBrandProfile = async (payload) => this._api.post("master/content/brand-profile/update", payload || {});
  generateHTMLByAI = async ({ title, excerpt, seo }) => this._api.post("master/content/post/generate_html_ai", { title, excerpt, seo });
  generateFacebookPostByAI = async ({ title, excerpt, content_html, seo }) =>
    this._api.post("master/content/post/generate_facebook_ai", { title, excerpt, content_html, seo });
  generateImageByAI = async ({ title, excerpt, prompt, folder_id = null }) => this._api.post("master/content/post/generate_image_ai", { title, excerpt, prompt, folder_id });
  generateTopicsByAI = async ({ topic, count }) => this._api.post("master/content/post/generate_topics_ai", { topic, count });
  bulkCreatePostsByAI = async ({ topics, status = "draft" }) => this._api.post("master/content/post/bulk_create_ai", { topics, status });
  pingGoogleSitemap = async ({ sitemap_url }) => this._api.post("master/content/sitemap/ping_google", { sitemap_url });
}

export default MasterContentService;
